module.exports = __webpack_public_path__ + "img/simhi2.d8620c3d.gif";